export const iconFontAwesomeFoodBeverageFishFins = (
	<i className="fa-solid fa-fish-fins"></i>
);
